var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTools(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 35.238,
    viewBox: "0 0 36 35.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-tools",
    "data-name": "Icon metro-tools",
    d: "M40.516,11.332a8.963,8.963,0,0,1-12.7,11.244l-2.479,2.708L27.1,27.06,28.159,26a1.382,1.382,0,0,1,1.956,0l8.573,8.66a1.382,1.382,0,0,1,0,1.956l-3.913,3.913a1.382,1.382,0,0,1-1.956,0l-8.573-8.66a1.382,1.382,0,0,1,0-1.956l.966-.966-1.686-1.69L11.67,40.212a2.766,2.766,0,0,1-3.913,0l-.978-.978a2.766,2.766,0,0,1,0-3.913L20.285,24.009l-8.97-8.994H8.481L5.2,9.742,7.841,7.1l5.392,3.3.035,2.774,9.075,9.11,2.64-2.21A8.972,8.972,0,0,1,35.612,6.451L29.8,12.183l4.893,4.893,5.824-5.744ZM10.023,36.7a1.384,1.384,0,1,0,0,1.958A1.384,1.384,0,0,0,10.023,36.7Z",
    transform: "translate(-5.202 -5.785)",
    fill: "#527991"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.4c96b976.svg";
export { ForwardRef as ReactComponent };